// if (shop_api.theme.gwp.activateParameter != '') {
//   const eligibilityParam = getUrlParameter(shop_api.theme.gwp.activateParameter);
//   if (shop_api.theme.gwp.enabled && eligibilityParam == shop_api.theme.gwp.activateParameterValue) {
//     localStorage.setItem('gwp_parameter', 'true');
//   }
// }

const gwpOffers = [
  {
    'type': 'A5 Planners',
    'gifts': [
      {
        id: shop_api.theme.gwp.gift_a_1_id,
        quantity: 'match'
      },
      {
        id: shop_api.theme.gwp.gift_a_2_id,
        quantity: 'match'
      }
    ]
  },
  {
    'type': 'A6 Planners',
    'gifts': [
      {
        id: shop_api.theme.gwp.gift_b_1_id,
        quantity: 1
      },
      {
        id: shop_api.theme.gwp.gift_b_2_id,
        quantity: 'match'
      }
    ]
  }
];

function getEligibleOffers(cart) {
  return cart.items.reduce((acc, item, index) => {
    gwpOffers.forEach((offer, index) => {
      if (item.product_type == offer.type && !acc.includes(index)) {
        acc.push(index);
      }
    });
    return acc;
  }, []);
}

function giftLineKeys(cart) {
  const gifts = cart.items.filter(item => item.properties['_gwp']);
  const keys = gifts.map(item => item.key);
  return keys;
}

function giftInCart(cart) {
  return cart.items.some(item => item.properties && item.properties['_gwp']);
}

function giftVariantIdInCart(cart, id, i) {
  return cart.items.some(item => item.id == id && item.properties && item.properties['_gwp_index'] == i);
}

function giftItemQuantity(cart, id, i) {
  const item = cart.items.find(item => item.id == id && item.properties && item.properties['_gwp_index'] == i);
  return item.quantity;
}

function giftVariantIdLineKey(cart, id, i) {
  const gwp = cart.items.find(item => item.id == id && item.properties['_gwp_index'] == i);
  const key = gwp.key;
  return key;
}

function hasOfferGift(cart, gifts, i) {
  return cart.items.some(item => item.properties && item.properties['_gwp_index'] == i && gifts.some(gift => gift.id == item.id));
}

function eligibleForOffer(cart, offer) {
  return cart.items.some(item => item.product_type == offer.type && item.properties && !item.properties['_gwp']);
}

function getOfferGifts(cart, offer, i) {
  return cart.items.filter(item => item.properties && item.properties['_gwp_index'] == i && offer.gifts.some(gift => gift.id == item.id));
}

function initGift(enabled, cart) {
  cartHasType(enabled, cart);
}

async function cartHasType(enabled, cart) {

  if (enabled) {

    for (let i = 0; i < gwpOffers.length; i++) {

      if (eligibleForOffer(cart, gwpOffers[i])) {

        const matchGifts = gwpOffers[i].gifts.filter(gift => gift.quantity === 'match' && gift.id !== '');
        console.log('matchGifts',matchGifts)

        if (matchGifts.length > 0) {

          for (let m = 0; m < matchGifts.length; m++) {
            const matchItemInCart = giftVariantIdInCart(cart, matchGifts[m].id, i);
            const eligibleLineItems = cart.items.filter(item => item.product_type == gwpOffers[i].type && !item.properties['_gwp'] && !item.properties['Bundle']);
            const eligibleQuantity = eligibleLineItems.reduce((acc, item) => acc + item.quantity, 0);
            if (matchItemInCart) {
              const matchItemQuantity = giftItemQuantity(cart, matchGifts[m].id, i);
              if (matchItemQuantity != eligibleQuantity) {
                const key = giftVariantIdLineKey(cart, matchGifts[m].id, i);
                const update = {
                  'id': key,
                  'quantity': eligibleQuantity
                };
                await CartJS.changeItems(update);
              }
            } else if (eligibleQuantity > 0) {
              const items = {
                items: [
                  {
                    id: matchGifts[m].id,
                    quantity: eligibleQuantity,
                    properties: {
                      '_gwp': true,
                      '_gwp_match': true,
                      '_gwp_index': i
                    }
                  }
                ]
              };
              await CartJS.addItems(items);
              break;
            }
          }
        }

        // let eligibilityParam;
        // if (shop_api.theme.gwp.activateParameter !== '') {
        //   eligibilityParam = getUrlParameter(shop_api.theme.gwp.activateParameter);
        // }

        // if (shop_api.theme.gwp.activateParameter !== '' && localStorage.getItem('gwp_parameter') != 'true') continue;

        // const singleGifts = gwpOffers[i].gifts.filter(gift => gift.quantity === 1);
        // if (singleGifts.length > 0) {
        //   const itemInCart = giftVariantIdInCart(cart, singleGifts[0].id, i);
        //   if (!itemInCart) {
        //     const items = {
        //       items: [
        //         {
        //           id: singleGifts[0].id,
        //           quantity: 1,
        //           properties: {
        //             '_gwp': true,
        //             '_gwp_single': true,
        //             '_gwp_index': i
        //           }
        //         }
        //       ]
        //     };
        //     await CartJS.addItems(items);
        //   }
        // }

      } else if (hasOfferGift(cart, gwpOffers[i].gifts, i) && !eligibleForOffer(cart, gwpOffers[i])) {
        const ineligibleOfferGifts = getOfferGifts(cart, gwpOffers[i], i);
        const keys = ineligibleOfferGifts.map(item => item.key);
        const data = {
          updates: {}
        };
        keys.map(key => {
          data.updates[key] = 0;
        });
        await CartJS.updateItems(data);
      }

    }

  } else if (!enabled && giftInCart(cart)) {

    const keys = giftLineKeys(cart);
    const data = {
      updates: {}
    };
    keys.map(key => {
      data.updates[key] = 0;
    });
    await CartJS.updateItems(data);

  }
}

// Cart change
document.addEventListener('rebuy:cart.change', (event) => {
  initGift(shop_api.theme.gwp.enabled, event.detail.cart.cart);
});